/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Filter_ClearInputs */

const cs_clients_filter_clear = /** @type {(inputs: Clients_Filter_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit filtry`)
};

const en_clients_filter_clear = /** @type {(inputs: Clients_Filter_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

/**
* | output |
* | --- |
* | "Clear filters" |
*
* @param {Clients_Filter_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_filter_clear = /** @type {((inputs?: Clients_Filter_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Filter_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_filter_clear(inputs)
	return cs_clients_filter_clear(inputs)
});